function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeartbeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3A5.611 5.611 0 0012 5.246 5.627 5.627 0 001.875 8.625c.006.895.162 1.782.462 2.625H6.35l1.277-1.916a.75.75 0 011.248 0l2.376 3.564.876-1.314a.75.75 0 01.624-.334H15a.75.75 0 110 1.5h-1.849l-1.277 1.916a.75.75 0 01-1.248 0L8.25 11.102l-.876 1.314a.75.75 0 01-.624.334H2.998c2.499 4.67 8.323 7.98 8.636 8.154a.75.75 0 00.733 0 29.75 29.75 0 004.822-3.518c3.275-2.948 4.936-5.895 4.936-8.761A5.632 5.632 0 0016.5 3z",
    fill: props.fill
  }));
}

export default SvgHeartbeat;